





















































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import CaluseForm from './caluseFormItem.vue';
import { FormModel } from 'ant-design-vue';
import { generateUUID } from '@/utils/other';
import SearchRequirement from '@/components/searchRequirement.vue';
import { CLOSE_TAG_VIEW_EVENT, pubsub } from '@/utils/pubsub';
import moment, {Moment} from 'moment';
import { solutionListInstance } from '@/model/SolutionListClass';
import { deepClone } from '@/utils/deepClone';

type IUpdateQuotationParams = ISolution.IRequest.IUpdateQuotationParams;
type IClause = ISolution.IClause;
type IClauseOption = ISolution.IClauseOption;
type ICategoryInfo = IQuotation.IResponse.ICategoryInfo;

interface IForm {
  requirementId: string;
  title: string;
  items: IClause[];
  workDates: Moment[];
  effectiveDays: number;
}

const momentStartOfHour = (momentObj: Moment): Moment => {
  return momentObj.startOf('hour');
};
const calculateDiffDays = (startDate: Moment, endDate: Moment): number => {
  return endDate.diff(startDate, 'days') + 1;
};

@Component({
  components: {
    CaluseForm,
    SearchRequirement,
  },
})
export default class SolutionForm extends Vue {
  @Ref() private readonly editSolutionForm!: FormModel;
  @Ref() private readonly searchRequirement!: SearchRequirement;
  @Prop({default: () => false}) private isCreate!: boolean;
  @Prop({default: () => []}) private requireClausesOption!: IClauseOption[];
  @Prop({ required: true }) private solutionInfo!: IUpdateQuotationParams;
  @Prop({ required: true }) private submit!: (
    updateInfo: IUpdateQuotationParams,
  ) => Promise<string>;
  private submitLoading = false;
  private projectId = '';
  get requireCategorys(): ICategoryInfo[] {
    return solutionListInstance.requireCategorys;
  }
  private rules = {
    requirementId: [
      {
        required: true,
        trigger: 'change',
        message: () => this.$t('form.required'),
      },
    ],
    title: [
      {
        required: true,
        trigger: 'blur',
        message: () => this.$t('form.required'),
      },
    ],
    effectiveDays: [
      {
        required: true,
        trigger: 'blur',
        message: () => this.$t('form.required'),
      },
    ],
    workDates: [
      {
        type: 'array',
        required: true,
        trigger: 'change',
        message: () => this.$t('form.required'),
      },
      {
        validator: this.validateWorkDates,
        trigger: 'change',
        message: '开发日期早于有效期',
      },
    ],
  };
  private form: IForm = {
    requirementId: '',
    title: '',
    workDates: [],
    items: [],
    effectiveDays: 5,
  };
  private validateWorkDates(
    rule: any,
    value: Moment[],
    callback: (err?: Error) => void,
  ) {
    const effectiveDate = moment().add(this.form.effectiveDays - 1, 'd');
    effectiveDate.startOf('d');
    if (value[0].isBefore(effectiveDate)) {
      callback(new Error());
    } else {
      callback();
    }
  }
  private workDateDisabledDate(current: Moment) {
    const effectiveDate = moment().add(this.form.effectiveDays - 1, 'd');
    return current && current < effectiveDate.startOf('d');
  }
  private created() {
    this.readyFormData();
  }
  @Watch('requireClausesOption')
  private watchRequireClauses(newVal: IClauseOption[]) {
    if (this.isCreate) {
      this.form.items = newVal.map((clause) => {
        return {
          id: generateUUID(),
          ...clause,
        };
      });
    }
  }
  private readyFormData() {
    if (this.isCreate) {
      const {items, requirementId} = this.solutionInfo;
      this.form = {
        requirementId,
        title: '',
        workDates: [],
        items: deepClone(items),
        effectiveDays: 5,
      };
    } else {
      const {title, startDate, endDate, items, requirementId, effectiveDays } = this.solutionInfo;
      this.form = {
        requirementId,
        title,
        workDates: startDate ? [moment(startDate), moment(endDate)] : [],
        items: deepClone(items),
        effectiveDays,
      };
    }
    this.$nextTick(() => {
      const {requirementId} = this.solutionInfo;
      if (requirementId) {
        this.searchRequirement.searchReqById(requirementId);
      }
    });
  }
  private readySubmitParams(): IUpdateQuotationParams {
    const { title, requirementId, items, workDates, effectiveDays } = this.form;
    const effectiveDate = moment().add(effectiveDays - 1, 'd');
    workDates[0] = momentStartOfHour(workDates[0]);
    workDates[1] = momentStartOfHour(workDates[1]);
    const params: IUpdateQuotationParams = {
      title,
      startDate: workDates[0].format('YYYY-MM-DD'),
      endDate: workDates[1].format('YYYY-MM-DD'),
      effectiveDate: effectiveDate.format('YYYY-MM-DD'),
      workDays: calculateDiffDays(workDates[0], workDates[1]),
      effectiveDays,
      items,
      requirementId,
    };
    return params;
  }
  private handleSubmit() {
    this.editSolutionForm.validate((valid) => {
      const clauseValidated = this.validateClause(this.form.items);
      if (!clauseValidated) {
        return false;
      }
      if (valid) {
        const newSolution = this.readySubmitParams();
        this.submitSolution(newSolution);
      } else {
        return false;
      }
    });
  }
  private submitSolution(newSolution: IUpdateQuotationParams) {
    this.submitLoading = true;
    this.submit(newSolution).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.submitLoading = false;
    });
  }
  private addClause() {
    this.form.items.push({
      id: generateUUID(),
      categoryId: '',
      title: '',
      manDay: 0,
    });
  }
  private removeClause(index: number, clauseId: string) {
    if (this.form.items.length <= 1) {
      this.displayMessage();
      return;
    }
    this.form.items.splice(index, 1);
  }
  private validateClause(quotations: IClause[]): boolean {
    let validateResult = true;
    if (quotations.length < 1) {
      validateResult = false;
      this.displayMessage();
    }
    quotations.forEach((item) => {
      if (!(this.$refs[`clause-${item.id}`] as CaluseForm[])[0].validate()) {
        validateResult = false;
      }
    });
    if (validateResult) {
      validateResult = this.checkCategoryType(quotations);
    }
    return validateResult;
  }
  private checkCategoryType(quotations: IClause[]) {
    const categorys = [...this.requireCategorys];
    quotations.forEach((item) => {
      if (categorys.length > 0) {
        const index = categorys.findIndex(
          (category) => item.categoryId === category.id,
        );
        if (index > -1) {
          categorys.splice(index, 1);
        }
      }
    });
    if (categorys.length > 0) {
      const tips = categorys.map((category) => category.name).join('、');
      const message = this.$t('solution.lackOfQuotation').toString();
      this.$message.warning(`${message}(${tips})`);
      return false;
    }
    return true;
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({ name: 'Solution' });
  }
  // 处理选项改变
  private handleRequirementChange(
    requirementInfo: IRequirement.IResponse.IRequirementInfo | null,
  ) {
    if (requirementInfo) {
      this.form.requirementId = requirementInfo.id;
      this.projectId = requirementInfo.projectId;
    } else {
      this.form.requirementId = '';
      this.projectId = '';
    }
  }
  private displayMessage() {
    const message = this.$t('solution.atLeast').toString();
    this.$message.warning(`${message}`);
  }
}
